export default __webpack_public_path__ + "media/heart-fill.cfde33eb.svg";